// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"ReviewCards_fullWidth__FzlGC","wrapper":"ReviewCards_wrapper__cYCcF","cta":"ReviewCards_cta__WK6Y0","reel":"ReviewCards_reel__z0l8R"};